import React from 'react';
import { useTranslation } from 'react-i18next';
import './footer.css';
import { FaMapMarkerAlt } from 'react-icons/fa';
import '@fortawesome/fontawesome-free/css/all.min.css';
import Homepagelogofooter from "./mezopitlogonew.png";

const Footer = () => {
  const { t } = useTranslation('footer');

  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-col company">
          <img src={Homepagelogofooter} alt={t('company.logoAlt')} className="footer-logo" />
          <p>
            {t('company.slogan')}
          </p>
        </div>

        <div className="footer-col">
          <h4>{t('explore.title')}</h4>
          <ul>
            <li><a href="/hizmet-alanlarimiz">{t('explore.services')}</a></li>
            <li><a href="/cozumlerimiz">{t('explore.cozumlerimiz')}</a></li>
            <li><a href="/paketlerimiz">{t('explore.packages')}</a></li>
            <li><a href="/son-tamamlanan-projelerimiz">{t('explore.projects')}</a></li>
          </ul>
        </div>

                <div className="footer-col">
          <h4>{t('aboutus.title')}</h4>
          <ul>
            <li><a href="/hakkimizda">{t('aboutus.about')}</a></li>
            <li><a href="/hakkimizda">{t('aboutus.references')}</a></li>
            <li><a href="/hakkimizda">{t('aboutus.partners')}</a></li>
            <li><a href="/sizin-kariyeriniz">{t('aboutus.career')}</a></li>
            <li><a href="/blog-sayfamiz">{t('aboutus.blog')}</a></li>
          </ul>
        </div>

        <div className="footer-col">
          <h4>{t('support.title')}</h4>
          <ul>
            <li><a href="/bizimle-iletisime-gecin">{t('support.customerSupport')}</a></li>
            <li><a href="/bizimle-iletisime-gecin">{t('support.maintenance')}</a></li>
            <li><a href="/sikca-sorulan-sorular-sss">{t('support.faq')}</a></li>
            <li><a href="/bizimle-iletisime-gecin">{t('support.contact')}</a></li>
          </ul>
        </div>

        <div className="footer-col">
          <h4>{t('legal.title')}</h4>
          <ul>
            <li><a href="/veri-güvenligi-politikamiz">{t('legal.dataSecurity')}</a></li>
            <li><a href="/gizlilik-politikamiz">{t('legal.privacy')}</a></li>
            <li><a href="/cerez-politikamiz">{t('legal.cookies')}</a></li>
            <li><a href="/kullanim-sartlarimiz">{t('legal.terms')}</a></li>
          </ul>
        </div>

        <div className="footer-col contact">
          <h4>{t('contact.title')}</h4>
          <ul>
            <li><FaMapMarkerAlt /> {t('contact.address')}</li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>{t('bottom.copyright')}</p>
        <div className="footersocial-icons">
          <a href="https://x.com/mezopitsoftion" target="_blank" rel="noopener noreferrer" aria-label={t('social.twitter')}><i className="fa-brands fa-x-twitter"></i></a>
          <a href="https://www.facebook.com/mezopitsoftware" target="_blank" rel="noopener noreferrer" aria-label={t('social.facebook')}><i className="fab fa-facebook"></i></a>
          <a href="https://www.linkedin.com/company/mezopit-software-solutions" target="_blank" rel="noopener noreferrer" aria-label={t('social.linkedin')}><i className="fab fa-linkedin"></i></a>
          <a href="https://www.instagram.com/mezopitsoftware" target="_blank" rel="noopener noreferrer" aria-label={t('social.instagram')}><i className="fab fa-instagram"></i></a>
          <a href="https://wa.me/qr/3EXNW3CQTQNHD1" target="_blank" rel="noopener noreferrer" aria-label={t('social.whatsapp')}><i className="fab fa-whatsapp"></i></a>
          <a href="https://youtube.com/@mezopitsoftwaresolutions?si=JrkkTh2wI0mjyVSn" target="_blank" rel="noopener noreferrer" aria-label={t('social.youtube')}><i className="fab fa-youtube"></i></a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;